// PageHeader.jsx — sayfa başlığı + breadcrumb (görünür gezinti ve BreadcrumbList JSON-LD için).

import React from 'react';
import { Link } from 'react-router-dom';
import { useLang } from '../i18n';

export default function PageHeader({ title, lead, crumbs = [], eyebrow, color }) {
  const { t, to } = useLang();
  return (
    <header className="page-head">
      <div className="container">
        <nav className="crumbs" aria-label="breadcrumb">
          <Link to={to('home')}>{t('brand')}</Link>
          {crumbs.map((c) => (
            <span key={c.label}>
              {' / '}
              {c.to ? <Link to={c.to}>{c.label}</Link> : <span aria-current="page">{c.label}</span>}
            </span>
          ))}
        </nav>
        {eyebrow && <div className="eyebrow" style={color ? { color } : undefined}>{eyebrow}</div>}
        <h1>{title}</h1>
        {lead && <p className="mb-0">{lead}</p>}
      </div>
    </header>
  );
}
